import {observable, makeObservable} from "mobx";

export default class VillageItem {
  id: string = "";
  name: string = "";

  constructor(id: string, name: string) {
    makeObservable(this, {
      id: observable,
      name: observable
    });
    this.id = id;
    this.name = name;
  }
}
